import * as types from './projectActionTypes';
import {projectStatusEnum} from '../../../../util/uiconstants';

const reducer = (state, action) => {
	switch (action.type) {
		case types.UPDATE_STEP1_DATA:
			return {
				...state,
				name: action.payload.name,
				clients: action.payload.clients,
				status: action.payload.status ? action.payload.status : projectStatusEnum.INITIAL,
				owners: action.payload.owners
			};

		case types.SAVE_AS_DRAFT:
			return {...state, status: projectStatusEnum.DRAFT};

		case types.UPDATE_STEP2_DATA:
			return {...state, orgStructure: action.payload};
		case types.UPDATE_SELECTED_CLIENTS:
			return {
				...state,
				clients: action.payload.clients
			};
		default:
			return state;
	}
};

export default reducer;
